import './AffiliateCard.css';

export default function AffiliateCard({ title, url, description }) {
  return (
    <article className="affiliate-card card mb-4 shadow-sm border-0">
      <div className="card-body">
        <div className="d-flex align-items-start justify-content-between mb-3">
          <div>
            <span className="text-uppercase text-muted small affiliate-card-label">
              Oferta Amazon
            </span>
            <h3 className="h6 affiliate-card-title mt-2 mb-0">
              {title}
            </h3>
          </div>
          <span className="badge rounded-pill bg-warning text-dark affiliate-card-badge">
            Afiliado
          </span>
        </div>

        {description && (
          <p className="affiliate-card-description text-secondary mb-3">
            {description}
          </p>
        )}

        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-sm"
        >
          Ver na Amazon
        </a>
      </div>
    </article>
  );
}
